import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { ReportType } from "ui/Scripts/source/models/enums";
import { AppUtils } from "source/framework/appUtils";
import { IReportGenerated2, ReportGenerated2 } from "source/models/report/reportGenerated2";
import { IReportItem } from "source/models/report/reportItem";
import { IReportParameterValue } from "source/models/report/reportParameterValue";
import * as eventService from "source/models/services/eventService";
import { PageReport } from "source/components/framework/Report/PageReport";
import { cloneEventGeneralFilter, getEventGeneralFilterChange, getEventGeneralFilterFromFilterState, IEventGeneralFilter, IEventPageFilterState } from "./EventPageUtils";

export interface IEventPageReportProp extends IEventPageFilterState {
    companyId: string;
    reports: IReportItem[];
    reportId: string;
    dataId?: string;
    onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
}

interface IEventPageReportState extends IEventGeneralFilter {
    isLoading: boolean;
    report: IReportItem;
    reportGenerated: IReportGenerated2;
    reportDataUri: string;
}

export class EventPageReport extends React.Component<IEventPageReportProp, IEventPageReportState> {
    parameterValues: IReportParameterValue[] = [];

    constructor(props: IEventPageReportProp) {
        super(props);
        const report = props.reportId ? props.reports.find(i => i.id === props.reportId) : null;
        this.parameterValues = report ? report.getReportParameterValues() : [];
        const generalFilterValues = getEventGeneralFilterFromFilterState(props);
        this.state = {
            ...generalFilterValues,
            isLoading: false,
            reportGenerated: null,
            reportDataUri: "",
            report: props.reportId ? props.reports.find(i => i.id === props.reportId) : null,
        };
    }

    createReport = async (report: IReportItem, genralFilter: IEventGeneralFilter) => {
        if (!report) return;
        let reportGenerated: ReportGenerated2 = null;
        if (report.type !== ReportType.Html) {
            this.setState({ isLoading: true });
            reportGenerated = await AppUtils.callService(() => eventService.getReportGenerated(this.props.companyId, report.reportId, report.title,
                genralFilter.startDate, genralFilter.endDate, genralFilter.dynamicTimeFilterId, genralFilter.unitIds, genralFilter.states, genralFilter.urgencyClassIds,
                genralFilter.eventTypeIds, genralFilter.eventTypeBIds, genralFilter.eventTypeCIds, genralFilter.partnerCompanyIds, genralFilter.createUserCodes,
                genralFilter.handlerUserCodes, genralFilter.observers, this.parameterValues), false, false, () => { this.setState({ isLoading: false }); });
            if (!reportGenerated) return;
        }
        const reportBlob = reportGenerated && reportGenerated.content ? Base.base64ToBlob(reportGenerated.content, reportGenerated.mediaType) : null;
        const reportDataUri = reportBlob ? await Base.blobToBase64(reportBlob) : "";
        this.setState({
            report,
            reportGenerated,
            reportDataUri,
            ...genralFilter
        });
    };

    componentDidMount(): void {
        const state = this.state;
        this.createReport(state.report, cloneEventGeneralFilter(state));
    }

    componentDidUpdate(prevProps: IEventPageReportProp, prevState: IEventPageReportState) {
        const props = this.props;
        const prevDataId = prevProps.dataId ? prevProps.dataId : "";
        const dataId = props.dataId ? props.dataId : "";
        const prevReportId = prevProps.reportId ? prevProps.reportId : "";
        const reportId = props.reportId ? props.reportId : "";
        const prevReportIds = prevProps.reports ? prevProps.reports.map(i => i.id) : [];
        const reportIds = props.reports ? props.reports.map(i => i.id) : [];
        const prevCompanyId = prevProps.companyId ? prevProps.companyId : "";
        const companyId = props.companyId ? props.companyId : "";
        const filterStateChange = getEventGeneralFilterChange(prevProps, props);
        const report = props.reportId ? props.reports.find(i => i.id === props.reportId) : null;
        const parameterValues = report ? report.getReportParameterValues() : [];
        if (dataId === prevDataId && reportId === prevReportId && companyId === prevCompanyId &&
            filterStateChange.notChanged && Base.equalStrArrays(prevReportIds, reportIds) &&
            JSON.stringify(this.parameterValues) === JSON.stringify(parameterValues)) return;
        this.parameterValues = parameterValues;
        this.createReport(reportId ? props.reports.find(i => i.id === reportId) : null, filterStateChange);
    }

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageReport
                isLoading={state.isLoading}
                report={state.report}
                reportGenerated={state.reportGenerated}
                reportDataUri={state.reportDataUri}
                sortingDisabled={true}
                onSetSortData={props.onSetSortData}
            />
        );
    }
}